export class URL {
  public static readonly RATES = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_RATES : 'https://api.n2p.io';
}
